///////COMPONENTS///////
import { put, select, takeLatest } from 'redux-saga/effects'
import ActionsTypes from '../../constants/ActionsTypes'
import { globalLoadingActionCreators, errorManagerActionCreators, salesHistoryManagerActionCreators, toastSuccessActionCreators } from '../actions'
import * as R from '../../constants/Endpoint'
import { API_TOKEN } from '../../config/AxiosConfig'
import { selectIdsUser } from '../selectors/user'

const getSalesHistory = function* ({ payload }) {
	const bodyMsg = payload.filters
	const user = yield select(selectIdsUser)
	const apiCall = R.GET_SALES_HISTORY(user['idUser'], payload.queryParams)
	yield put(globalLoadingActionCreators.startLoading())

	try {
		const data = yield API_TOKEN(user.jwt).post(apiCall, bodyMsg)
		yield put(salesHistoryManagerActionCreators.getSalesHistorySuccess(data.data))
	} catch (e) {
		yield put(errorManagerActionCreators.createError(e.response))

		yield put(salesHistoryManagerActionCreators.getSalesHistoryFailure(e.response))

		yield put(globalLoadingActionCreators.endLoading())
	}
}

const sendMerchantTicket = function* ({ payload }) {
	const user = yield select(selectIdsUser)

	const apiCall = R.SEND_MERCHANT_TICKET(payload.id)

	yield put(globalLoadingActionCreators.startLoading())
	try {
		const data = yield API_TOKEN(user.jwt).get(apiCall)
		yield put(salesHistoryManagerActionCreators.sendMerchantTicketSuccess(data.data))

		// No display of any success / failure
		yield put(toastSuccessActionCreators.hydrateToast('toast__transactionsHistory__admin__consignmentContract'))
	} catch (e) {
		// No display of any success / failure
		//yield put(errorManagerActionCreators.createError(e.response));

		yield put(salesHistoryManagerActionCreators.sendMerchantTicketFailure(e.response))
	} finally {
		yield put(globalLoadingActionCreators.endLoading())
	}
}
const sendGuestTicket = function* ({ payload }) {
	const user = yield select(selectIdsUser)
	const bdyMsg = payload.data
	const apiCall = R.SEND_GUEST_TICKET(payload.id)

	yield put(globalLoadingActionCreators.startLoading())
	try {
		const data = yield API_TOKEN(user.jwt).put(apiCall, bdyMsg)
		yield put(salesHistoryManagerActionCreators.sendGuestTicketSuccess(data.data))

		// No display of any success / failure
		yield put(toastSuccessActionCreators.hydrateToast('toast__transactionsHistory__admin__customerTicket__sendSuccess_body'))
	} catch (e) {
		// No display of any success / failure
		//yield put(errorManagerActionCreators.createError(e.response));

		yield put(salesHistoryManagerActionCreators.sendGuestTicketFailure(e.response))
	} finally {
		yield put(globalLoadingActionCreators.endLoading())
	}
}

const sagas = function* () {
	yield takeLatest(ActionsTypes.GET_SALES_HISTORY, getSalesHistory)
	yield takeLatest(ActionsTypes.SEND_MERCHANT_TICKET, sendMerchantTicket)
	yield takeLatest(ActionsTypes.SEND_GUEST_TICKET, sendGuestTicket)
}

export default sagas
